module.exports = __webpack_public_path__ + "img/ramon.0444c62c.png";